/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
// import {FormControlDiv} from '../../modules-menu/module-search-filter/ModuleSearchFilterStyle';
// import SelectInput from '@components/form/select-input/SelectInput';
import {
  getPageData,
  getSearchResultsData
} from '@shared/services/service-handlers/PrivateService';
import {useParams} from 'react-router-dom';
import EncryptUtils from 'src/utils/EncryptUtils';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import FormConstants from '@shared/constants/FormConstants';
import {useTranslation} from 'react-i18next';
import {LegacyAppDiv} from './SubModulePageSectionStyles';
import {useAppContext} from '@context/AppContext';
import * as Yup from 'yup';
import {RHFAutocomplete} from 'src/minimal-components/hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import FormProvider from 'src/components/hook-form';
import {label} from 'yet-another-react-lightbox';
interface LegacyAppFilterProps {
  setParentLegacyValue?: (data: string) => void;
  record_id: string;
  defaultLegacyAppValue?: string;
}
const LegacyAppFilter = (props: LegacyAppFilterProps): React.ReactElement => {
  const {
    appState: {applicationName}
  } = useAppContext();
  const {setParentLegacyValue, record_id, defaultLegacyAppValue} = props;
  const {enqueueSnackbar} = useSnackbar();
  const {t} = useTranslation();
  const params = useParams();
  const [state, setState] = useState({
    dropdownValues: [],
    legacyValue: ''
  });
  const {dropdownValues} = state;
  const NewUserSchema = Yup.object().shape({
    LegacyApp: Yup.object().shape({label: Yup.string()})
  });
  const defaultValues = useMemo(
    () => ({
      LegacyApp: {label: defaultLegacyAppValue || ''}
    }),
    [defaultLegacyAppValue]
  );

  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues
  });
  const {control, setValue} = methods;
  const sqlData = {
    // eslint-disable-next-line max-len
    sql: `SELECT DISTINCT DEMO.LegacyApp FROM Clinical.Demographics DEMO WITH (NOLOCK) JOIN MPIMapping MAP WITH (NOLOCK) ON MAP.LegacyApp = DEMO.LegacyApp AND MAP.LegacyMRN = DEMO.LegacyMRN JOIN MPI WITH (NOLOCK) ON MPI.PatientID = MAP.PatientID  WHERE MPI.PatientID='${record_id}' ORDER BY DEMO.LegacyApp`,
    variables: [{}]
  };
  const init = async () => {
    if (params?.module_name === FormConstants.MODULE.FILECABINET) {
      const sql_query = {
        sql: 'SELECT distinct LegacyApp FROM filecabinet.filecabinetdocument A WHERE ###documentSecurityGroupIDs',
        variables: [{}],
        schema: 'A',
        filter_schema_clause: 'A'
      };
      try {
        const values: any = {
          sql_data: sql_query,
          is_legacy_app_dropdown: `SELECT distinct LegacyApp FROM filecabinet.filecabinetdocument A WHERE ###documentSecurityGroupIDs`,
          add_document_security_ids: true
        };
        const encryptRequestData = EncryptUtils.encryptedData(values);
        const result = await getSearchResultsData(
          applicationName,
          params.module_name || '',
          {
            tk: encryptRequestData
          }
        );
        setState((prevState: any) => ({
          ...prevState,
          legacyValue: '',
          dropdownValues: result?.data
        }));
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    } else {
      try {
        const values: any = {
          sql_data: sqlData,
          user_id: record_id,
          is_legacy_app_dropdown: true
        };
        const encryptRequestData = EncryptUtils.encryptedData(values);
        const result = await getPageData(
          applicationName,
          params.module_name || '',
          params.submodule_name || '',
          {
            tk: encryptRequestData
          }
        );
        setState((prevState: any) => ({
          ...prevState,
          dropdownValues: result?.data
        }));
      } catch (e) {
        const errMessage = getErrorMessage(e);
        enqueueSnackbar(errMessage, SnackBarConfig.getError());
      }
    }
  };

  // pre-filling the form
  // const setInitialValues = () => {
  //   setValue(FormConstants.LEGACY_APP.LEGACY_APP, defaultLegacyAppValue);
  // };
  useEffect(() => {
    init();
    // setInitialValues();
  }, []);
  const formattedDropdownValues = [{label: 'All'}];
  formattedDropdownValues.push(
    ...dropdownValues.map((option: any) => ({
      label: option?.LegacyApp || ''
    }))
  );

  useEffect(() => {
    const value = defaultLegacyAppValue ? defaultLegacyAppValue : 'All';
    if (value) {
      setValue('LegacyApp', {label: value});
    }
  }, [defaultLegacyAppValue]);

  return (
    // <LegacyAppDiv>
    //   {renderSelectFields(FormConstants.LEGACY_APP.LEGACY_APP)}
    // </LegacyAppDiv>
    <LegacyAppDiv>
      <FormProvider methods={methods}>
        <RHFAutocomplete
          name={FormConstants.LEGACY_APP.LEGACY_APP}
          type={FormConstants.LEGACY_APP.LEGACY_APP}
          autoHighlight
          fullWidth
          size="small"
          label={t('PRIVATE.LEGACY_APP.SELECT_LEGACY_APP', {ns: 'private'})}
          placeholder={t('PRIVATE.LEGACY_APP.SELECT_LEGACY_APP', {
            ns: 'private'
          })}
          options={formattedDropdownValues}
          getOptionLabel={(option: any) => option.label}
          renderOption={(props, option) => (
            <li {...props} key={option.label}>
              {option.label}
            </li>
          )}
          isOptionEqualToValue={(option, value) => {
            return option.label === value.label;
          }}
          onChange={(event, newValue: any) => {
            const selectedValue = newValue?.label ?? '';
            setState((prevState: any) => ({
              ...prevState,
              legacyValue: selectedValue
            }));
            if (
              setParentLegacyValue &&
              typeof setParentLegacyValue === 'function'
            ) {
              if (selectedValue === 'All') {
                setParentLegacyValue('');
              } else {
                setParentLegacyValue(selectedValue);
              }
            }
          }}
          value={methods.watch('LegacyApp')} // bind form value here
          defaultLegacyAppValue={defaultLegacyAppValue}
        />
      </FormProvider>
    </LegacyAppDiv>
  );
};

export default LegacyAppFilter;
